package net.sergeych.tools

actual fun ProtectedOp(): ProtectedOpImplementation = object : ProtectedOpImplementation {
    // JS targets are inherently single-threaded, so we do noting:
    override fun <T> invoke(f: () -> T): T = f()
}